// node-modules
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import { TweenLite, Power1 } from 'gsap/TweenMax';
import { ScrollToPlugin } from 'gsap/all';

// polyfills
import 'dom4';

// default components
import '@/components/lazy-load';
import '@/components/preloader';
import '@/components/footer';
import '@/components/scrollToTop';
import '@/components/header';
import '@/components/animations';
import '@/components/buttons';
import '@/components/modals';

// functional components
import { scrollDownInit } from '@/components/scrollDown';
import { menuToggle } from '@/components/hamburgerMenu';
import {
  programsSlider,
  successCareerSlider,
  careersSlider,
  campusesSlider,
  postSlider,
  facultySlider,
  imagesGridSlider,
  detailSlider,
  gallerySlider,
  alumniListSlider,
} from '@/components/swiperSlider';
import { Form } from '@/components/Form';
import { customSelect } from '@/components/customSelect';
import { teamMember } from '@/components/Team-member';
import { moveImage } from '@/components/moveImage';
import { searchFormMobile } from '@/components/searchFormMobile';
import { ctaBlock } from '@/components/ctaBlock';
import { Tabs } from '@/components/tabs';
import { Dropdown } from '@/components/Dropdown';
import { initGoogleMaps } from '@/components/googleMaps';
import { uploadFile } from './components/uploadFile';
import { datePick } from './components/datePick';
import { filters } from './components/filters';
// assets
import 'styles/tailwind-init.css';
import 'styles/main.scss';
import 'fonts';
import initAccordion from './components/accordion';


// eslint-disable-next-line
const plugins = [ScrollToPlugin];

TweenLite.defaultEase = Power1.easeOut;


document.addEventListener('DOMContentLoaded', () => {
  objectFitImages();
  svg4everybody();
  // init scroll-down button
  scrollDownInit();
  // init menu
  menuToggle();
  // init sliders
  // document.querySelectorAll('[data-role="slider-study"]')
  //   .forEach(container => studySlider(container));

  document.querySelectorAll('[data-role="slider-programs"]')
    .forEach(container => programsSlider(container));
  document.querySelectorAll('[data-role="slider-success-career"]')
    .forEach(container => successCareerSlider(container));
  document.querySelectorAll('[data-role="slider-careers"]')
    .forEach(container => careersSlider(container));
  document.querySelectorAll('[data-role="slider-campuses"]')
    .forEach(container => campusesSlider(container));
  document.querySelectorAll('[data-role="slider-post"]')
    .forEach(container => postSlider(container));
  document.querySelectorAll('[data-role="slider-faculty"]')
    .forEach(container => facultySlider(container));
  document.querySelectorAll('[data-role="slider-images-grid"]')
    .forEach(container => imagesGridSlider(container));
  document.querySelectorAll('[data-role="slider-detail"]')
    .forEach(container => detailSlider(container));
  document.querySelectorAll('[data-role="slider-alumni-list"]')
    .forEach(container => alumniListSlider(container));
  gallerySlider();

  // init form
  document.querySelectorAll('[data-role="contact-form"]')
    .forEach(element => new Form(element));
  // selects
  document.querySelectorAll('[data-custom-select]')
    .forEach(el => customSelect(el));
  // init date pick
  datePick();
  // team member
  teamMember();
  // move image section
  moveImage();
  // init form for mobile
  searchFormMobile();
  // init cta
  ctaBlock();
  // init google maps
  document.querySelectorAll('[data-role="google-maps-container"]')
    .forEach(el => initGoogleMaps(el));
  // init tabs
  document.querySelectorAll('[data-role="tab-list-container"]')
    .forEach(el => new Tabs({
      mainContainer: el,
    }));
  // init dropdown
  document.querySelectorAll('[data-role*="dropdown-container"]')
    .forEach(element => new Dropdown({ element }));
  // init upload file
  uploadFile();

  document.querySelectorAll('[data-accordion]').forEach(container => initAccordion(container));

  filters();
});
